jQuery.validator.addMethod('dni', function(value, element) {
    'use strict';
    var cadenadni = 'TRWAGMYFPDXBNJZSQVHLCKET';
    var word = value.substr((value.length - 1), 1);
    var letra = '';
    var numero = '';
    if (/^([0-9]{8})*[a-zA-Z]+$/.test(value)) {
        numero = value.substr(0, value.length - 1) % 23;
        letra = cadenadni.substring(numero, numero + 1);
        if (letra == word) {
            return true;
        }
        return false;
    } else if (/^[XYZ]{1}/.test(value)) {
        var reemplazar = new Array('X', 'Y', 'Z');
        var por = new Array('0', '1', '2');
        numero = value;
        for (var i = 0; i < reemplazar.length; i++) {
            numero = numero.replace(reemplazar[i].toUpperCase(), por[i]);
        }
        numero = numero.substr(0, value.length - 1) % 23;
        letra = cadenadni.substring(numero, numero + 1);
        if (letra == word) {
            return true;
        }
        return false;
    }
    return this.optional(element);
}, 'Please enter a valid DNI.');

$.validator.addMethod('filesize', function (value, element, param) {
    return this.optional(element) || (element.files[0].size <= param)
}, 'File size must be less than {0}');


jQuery.validator.addClassRules("maxFileUploadGroup", {
	maxFileUploadGroup: 60
});

$.validator.addMethod('maxFileUploadGroup', function (value, element, maxMegabytes) {

	var BYTES_PER_MEGABYTE = 1048576;
	var maxBytes = maxMegabytes * BYTES_PER_MEGABYTE

	var $fields = $( '.maxFileUploadGroup', element.form ),
	$fieldsFirst = $fields.eq( 0 ),
	validator = $fieldsFirst.data( "valid_max_upload_grp" ) ? $fieldsFirst.data( "valid_max_upload_grp" ) : $.extend( {}, this );

	// Store the cloned validator for future validation
	$fieldsFirst.data( "valid_max_upload_grp", validator );

	var totalFileSizes = 0;
	$fields.each(function(index, input){
		if (typeof input.files[0] !== 'undefined') {
			totalFileSizes += input.files[0].size;
		}
	});
	isValid = (totalFileSizes <= maxBytes);

	// If element isn't being validated, run each require_from_group field's validation rules
	if ( !$( element ).data( "being_validated" ) ) {
		$fields.data( "being_validated", true );
		$fields.each( function() {
			validator.element( this );
		} );
		$fields.data( "being_validated", false );
	}
	return isValid;
}, $.validator.format('Files size must be less than {0}Mb.'));

jQuery.validator.addMethod('exactlength', function(value, element, param) {
    'use strict';
    return this.optional(element) || value.length == param;
}, $.validator.format('Please enter exactly {0} characters.'));

jQuery.validator.addMethod('duplicateControl', function(value, element, param) {
    'use strict';
    var formId = $('#formId').val();
    var data = {form: formId, item: param, value: value};
    result = $.ajax({
        type: 'POST',
        url: urlBase + '/media/js/formularis/ajax_hasDuplicateItems.php',
        data: data,
        async: false
    }).responseText;

    return this.optional(element) || result != 1;
}, 'Please enter another value, this field does not allow duplicates.');

$(document).ready(function() {
    'use strict';
    var lang = $('html').attr('lang');
    if (lang === 'ca' || lang === 'va' ) {
        jQuery.extend(jQuery.validator.messages, {
            dni: 'Si us plau, entreu un DNI vàlid.',
            exactlength: $.validator.format('Si us plau, entreu exactament {0} caràctes.'),
            duplicateControl: 'Si us plau, entreu un altre valor. Aquest camp no permet duplicats.',
            maxFileUploadGroup: $.validator.format('La mida de tots els fitxers ha de ser inferior a {0}Mb.')
        });
    } else if (lang === 'es') {
        jQuery.extend(jQuery.validator.messages, {
            dni: 'Por favor, escribe un DNI válido.',
            exactlength: $.validator.format('Por favor, escribe exactamente {0} caracteres.'),
            duplicateControl: 'Por favor, escribe otro valor. Este campo no admite duplicados.',
            maxFileUploadGroup: $.validator.format('El tamaño de todos los archivos debe ser inferior a {0}Mb.')
        });
    }
});
